import { request } from "../request";

export default {
    getThemes: ({ page }) => request(`themes?page=${page ? page : 1}`),
    getIndustries: ()=> request('industries')
};